var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('skeleton-loader',{staticClass:"radial-progress-loader",attrs:{"width":_vm.size,"height":_vm.size,"border-radius":"50%"}})}
var staticRenderFns = []

export { render, staticRenderFns }